/*
 * Scroll Button
 * Manages the button or group of buttons for scroll up or down
 * MIT License
 */
(function($) {

    $('.btn-scroll-down').each(function () {
        $(this).on('click', function () {
            let data_container = $($(this).attr('data-container'));
            window.scroll({
                top: data_container.position().top + data_container.outerHeight(true),
                left: 0,
                behavior: 'smooth'
            });
        });
    });
    
})(jQuery);